export const ELECTRICITY_PRICE = 'elektros_kaina';
export const WATER_PRICE = 'vandens_kaina';
